"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var PlaceAction;
(function (PlaceAction) {
    PlaceAction.PLACE_SHOW_POP = 'PLACE_SHOW_POP';
    PlaceAction.PLACE_SET_MAP_TYPE = 'PLACE_SET_MAP_TYPE';
    PlaceAction.PLACE_FULL_SIZE = 'PLACE_FULL_SIZE';
    PlaceAction.SET_STICKY = 'SET_STICKY';
    PlaceAction.PLACE_SET_NEIGHBOUTHOOD_GROUP_ACTIVE = 'PLACE_SET_NEIGHBOUTHOOD_GROUP_ACTIVE';
    PlaceAction.PLACE_TOGGLE_NEIGHBOUTHOOD_GROUP_ACTIVE = 'PLACE_TOGGLE_NEIGHBOUTHOOD_GROUP_ACTIVE';
    PlaceAction.PLACE_SET_NEARBY_TYPE = 'PLACE_SET_NEARBY_TYPE';
    PlaceAction.PLACE_SET_FULL_GALLERY_WIDTH = 'PLACE_SET_FULL_GALLERY_WIDTH';
    PlaceAction.PLACE_PROPERTY_LINK_CLICKED = 'PLACE_PROPERTY_LINK_CLICKED';
    PlaceAction.PLACE_PROPERTY_ENQUIRE_CLICKED = 'PLACE_PROPERTY_ENQUIRE_CLICKED';
    PlaceAction.PLACE_FOLLOW_CLICKED = 'PLACE_FOLLOW_CLICKED';
    PlaceAction.PLACE_UNFOLLOW_CLICKED = 'PLACE_UNFOLLOW_CLICKED';
    PlaceAction.PLACE_TOGGLE_NEIGHBOUR_MOBILE_ACTIVE = 'PLACE_TOGGLE_NEIGHBOUR_MOBILE_ACTIVE';
    PlaceAction.PLACE_SET_NEIGHBOUR_MOBILE_ACTIVE = 'PLACE_SET_NEIGHBOUR_MOBILE_ACTIVE';
    PlaceAction.PLACE_SET_NEIGHBOUR_FILTER_TYPE = 'PLACE_SET_NEIGHBOUR_FILTER_TYPE';
    PlaceAction.PLACE_CHANGE_DISTRICT_INFO = 'PLACE_CHANGE_DISTRICT_INFO';
    PlaceAction.PLACE_ON_ENQUIRE_CLICKED = 'PLACE_ON_ENQUIRE_CLICKED';
    PlaceAction.PLACE_ON_TOGGLE_SORT = 'PLACE_ON_TOGGLE_SORT';
    PlaceAction.PLACE_ON_SET_ORDER = 'PLACE_ON_SET_ORDER';
    PlaceAction.PLACE_ON_SET_SORT = 'PLACE_ON_SET_SORT';
    PlaceAction.PLACE_SET_SAVESEARCH_ID = 'PLACE_SET_SAVESEARCH_ID';
    PlaceAction.PLACE_SET_SUBITEM = 'PLACE_SET_SUBITEM';
    PlaceAction.PLACE_ON_SUBITEM_CLICK = 'PLACE_ON_SUBITEM_CLICK';
    PlaceAction.PLACE_ON_ADD_PLACE_CLICK = 'PLACE_ON_ADD_PLACE_CLICK';
    PlaceAction.PLACE_SET_ADD_PLACE_BUTTON_ACTIVE = 'PLACE_SET_ADD_PLACE_BUTTON_ACTIVE';
    PlaceAction.PLACE_SIMILAR_PREV = 'PLACE_SIMILAR_PREV';
    PlaceAction.PLACE_SIMILAR_NEXT = 'PLACE_SIMILAR_NEXT';
    PlaceAction.PLACE_GALLERY_ITEM_CLICKED = 'PLACE_GALLERY_ITEM_CLICKED';
    PlaceAction.PLACE_SET_GALLERY_INDEX = 'PLACE_SET_GALLERY_INDEX';
    PlaceAction.PLACE_SET_TOP_GALLERY_SCROLL = 'PLACE_SET_TOP_GALLERY_SCROLL';
    PlaceAction.PLACE_FAV_CLICKED = 'PLACE_FAV_CLICKED';
    PlaceAction.PLACE_SET_AVAILABLE_ITEM_IS_SAVED = 'PLACE_SET_AVAILABLE_ITEM_IS_SAVED';
    PlaceAction.PLACE_SET_AVAILABLE_ITEMS_IS_SAVED = 'PLACE_SET_AVAILABLE_ITEMS_IS_SAVED';
    PlaceAction.PLACE_ON_FAQ_CLICKED = 'PLACE_ON_FAQ_CLICKED';
    PlaceAction.PLACE_ON_FOLLOW_POPUP_CLOSE_CLICKED = 'PLACE_ON_FOLLOW_POPUP_CLOSE_CLICKED';
    PlaceAction.PLACE_SET_FOLLOW_POPUP_ACTIVE = 'PLACE_SET_FOLLOW_POPUP_ACTIVE';
    PlaceAction.PLACE_SET_MAP_READY = 'PLACE_SET_MAP_READY';
    PlaceAction.PLACE_ON_GALLERY_MAP_CLICKED = 'PLACE_ON_GALLERY_MAP_CLICKED';
    PlaceAction.PLACE_FORCE_VIEW_MORE_FACTS = 'PLACE_FORCE_VIEW_MORE_FACTS';
    PlaceAction.PLACE_FORCE_VIEW_MORE_FEATURES = 'PLACE_FORCE_VIEW_MORE_FEATURES';
    PlaceAction.PLACE_FORCE_VIEW_MORE_ABOUT = 'PLACE_FORCE_VIEW_MORE_ABOUT';
    PlaceAction.PLACE_SET_VIDEO_POPUP_ACTIVE = 'PLACE_SET_VIDEO_POPUP_ACTIVE';
    PlaceAction.PLACE_ON_SORT_UPDATE_COMPLETED = 'PLACE_ON_SORT_UPDATE_COMPLETED';
    PlaceAction.PLACE_ON_CHART_TYPE_SELECTED = 'PLACE_ON_CHART_TYPE_SELECTED';
    PlaceAction.PLACE_ON_CHART_INDEX_SELECT = 'PLACE_ON_CHART_INDEX_SELECT';
    PlaceAction.PLACE_ON_CHART_SET_CHART_POPUP = 'PLACE_ON_CHART_SET_CHART_POPUP';
    PlaceAction.PLACE_ON_TRANSACTION_CHANGE_PAGE = 'PLACE_ON_TRANSACTION_CHANGE_PAGE';
    PlaceAction.showPop = typesafe_actions_1.createAction(PlaceAction.PLACE_SHOW_POP, function (resolve) {
        return function (popState) {
            return resolve(popState);
        };
    });
    PlaceAction.setMapType = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_MAP_TYPE, function (resolve) {
        return function (mapType) {
            return resolve(mapType);
        };
    });
    PlaceAction.fullsize = typesafe_actions_1.createAction(PlaceAction.PLACE_FULL_SIZE, function (resolve) {
        return function (index) {
            return resolve(index);
        };
    });
    PlaceAction.setSticky = typesafe_actions_1.createAction(PlaceAction.SET_STICKY, function (resolve) { return function (isSticky) {
        return resolve(isSticky);
    }; });
    PlaceAction.setNeighbourhoodGroupActive = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_NEIGHBOUTHOOD_GROUP_ACTIVE, function (resolve) {
        return function (index) {
            return resolve(index);
        };
    });
    PlaceAction.toggleNeighbourhoodGroupActive = typesafe_actions_1.createAction(PlaceAction.PLACE_TOGGLE_NEIGHBOUTHOOD_GROUP_ACTIVE, function (resolve) {
        return function (index) {
            return resolve(index);
        };
    });
    PlaceAction.setNearbyType = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_NEARBY_TYPE, function (resolve) {
        return function (type) {
            return resolve(type);
        };
    });
    PlaceAction.propertyLinkClicked = typesafe_actions_1.createAction(PlaceAction.PLACE_PROPERTY_LINK_CLICKED, function (resolve) { return function (link) { return resolve(link); }; });
    PlaceAction.propertyEnquireClicked = typesafe_actions_1.createAction(PlaceAction.PLACE_PROPERTY_ENQUIRE_CLICKED, function (resolve) { return function (item) { return resolve(item); }; });
    PlaceAction.followClicked = typesafe_actions_1.createAction(PlaceAction.PLACE_FOLLOW_CLICKED, function (resolve) { return function () { return resolve(); }; });
    PlaceAction.unfollowClicked = typesafe_actions_1.createAction(PlaceAction.PLACE_UNFOLLOW_CLICKED, function (resolve) { return function () { return resolve(); }; });
    PlaceAction.toggleNeighbourMobileFilter = typesafe_actions_1.createAction(PlaceAction.PLACE_TOGGLE_NEIGHBOUR_MOBILE_ACTIVE, function (resolve) { return function () { return resolve(); }; });
    PlaceAction.setNeighbourMobileFilter = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_NEIGHBOUR_MOBILE_ACTIVE, function (resolve) {
        return function (status) { return resolve(status); };
    });
    PlaceAction.setNeighbourFilterType = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_NEIGHBOUR_FILTER_TYPE, function (resolve) {
        return function (type) { return resolve(type); };
    });
    PlaceAction.changeDistrictInfo = typesafe_actions_1.createAction(PlaceAction.PLACE_CHANGE_DISTRICT_INFO, function (resolve) {
        return function (i) { return resolve(i); };
    });
    PlaceAction.onEnquireClicked = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_ENQUIRE_CLICKED, function (resolve) {
        return function () { return resolve(); };
    });
    PlaceAction.onToggleSort = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_TOGGLE_SORT, function (resolve) {
        return function (type, filterType) { return resolve({ type: type, filterType: filterType }); };
    });
    PlaceAction.setSort = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_SET_SORT, function (resolve) {
        return function (field, filterType) { return resolve({ field: field, filterType: filterType }); };
    });
    PlaceAction.setOrder = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_SET_ORDER, function (resolve) {
        return function (order, filterType) { return resolve({ order: order, filterType: filterType }); };
    });
    PlaceAction.setFullGalleryWidth = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_FULL_GALLERY_WIDTH, function (resolve) {
        return function (width) { return resolve(width); };
    });
    PlaceAction.setSaveSearchId = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_SAVESEARCH_ID, function (resolve) {
        return function (id) { return resolve(id); };
    });
    PlaceAction.setSubitems = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_SUBITEM, function (resolve) {
        return function (type, items) { return resolve({ type: type, items: items }); };
    });
    PlaceAction.onSubitemClick = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_SUBITEM_CLICK, function (resolve) {
        return function (index, point) { return resolve({ index: index, point: point }); };
    });
    PlaceAction.addPlaceClick = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_ADD_PLACE_CLICK, function (resolve) {
        return function () { return resolve(); };
    });
    PlaceAction.setAddPlaceButtonActive = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_ADD_PLACE_BUTTON_ACTIVE, function (resolve) {
        return function (state) { return resolve(state); };
    });
    PlaceAction.similarNext = typesafe_actions_1.createAction(PlaceAction.PLACE_SIMILAR_NEXT, function (resolve) {
        return function () { return resolve(); };
    });
    PlaceAction.similarPrev = typesafe_actions_1.createAction(PlaceAction.PLACE_SIMILAR_PREV, function (resolve) {
        return function () { return resolve(); };
    });
    PlaceAction.onGalleryItemClicked = typesafe_actions_1.createAction(PlaceAction.PLACE_GALLERY_ITEM_CLICKED, function (resolve) {
        return function (src) { return resolve(src); };
    });
    PlaceAction.setGalleryIndex = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_GALLERY_INDEX, function (resolve) {
        return function (i) { return resolve(i); };
    });
    PlaceAction.setTopGalleryScroll = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_TOP_GALLERY_SCROLL, function (resolve) {
        return function (i) { return resolve(i); };
    });
    PlaceAction.favClicked = typesafe_actions_1.createAction(PlaceAction.PLACE_FAV_CLICKED, function (resolve) {
        return function (item) { return resolve(item); };
    });
    PlaceAction.setAvailableItemIsSaved = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_AVAILABLE_ITEM_IS_SAVED, function (resolve) {
        return function (id, state) { return resolve({ id: id, state: state }); };
    });
    PlaceAction.setAvailableItemsIsSaved = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_AVAILABLE_ITEMS_IS_SAVED, function (resolve) {
        return function (ids, state) { return resolve({ ids: ids, state: state }); };
    });
    PlaceAction.onFaqClicked = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_FAQ_CLICKED, function (resolve) {
        return function (index) { return resolve(index); };
    });
    PlaceAction.onFollowPopupCloseClick = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_FOLLOW_POPUP_CLOSE_CLICKED, function (resolve) {
        return function () { return resolve(); };
    });
    PlaceAction.setFollowPopupActive = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_FOLLOW_POPUP_ACTIVE, function (resolve) {
        return function (active) { return resolve(active); };
    });
    PlaceAction.setGoogleMapReady = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_MAP_READY, function (resolve) {
        return function (ready) { return resolve(ready); };
    });
    PlaceAction.onGalleryMapClicked = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_GALLERY_MAP_CLICKED, function (resolve) {
        return function () { return resolve(); };
    });
    PlaceAction.forceFactsViewMore = typesafe_actions_1.createAction(PlaceAction.PLACE_FORCE_VIEW_MORE_FACTS, function (resolve) {
        return function () { return resolve(); };
    });
    PlaceAction.forceFeaturesViewMore = typesafe_actions_1.createAction(PlaceAction.PLACE_FORCE_VIEW_MORE_FEATURES, function (resolve) {
        return function () { return resolve(); };
    });
    PlaceAction.forceAboutViewMore = typesafe_actions_1.createAction(PlaceAction.PLACE_FORCE_VIEW_MORE_ABOUT, function (resolve) {
        return function () { return resolve(); };
    });
    PlaceAction.setVideoPopupActive = typesafe_actions_1.createAction(PlaceAction.PLACE_SET_VIDEO_POPUP_ACTIVE, function (resolve) { return function (isActive) { return resolve(isActive); }; });
    PlaceAction.onSortUpdateCompleted = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_SORT_UPDATE_COMPLETED, function (resolve) { return function () { return resolve(); }; });
    PlaceAction.onChartTypeSelect = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_CHART_TYPE_SELECTED, function (resolve) { return function (chartType) { return resolve(chartType); }; });
    PlaceAction.onChartIndexSelect = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_CHART_INDEX_SELECT, function (resolve) { return function (index) { return resolve(index); }; });
    PlaceAction.setChartPopup = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_CHART_SET_CHART_POPUP, function (resolve) { return function (popup) { return resolve(popup); }; });
    PlaceAction.onTransactionChangePage = typesafe_actions_1.createAction(PlaceAction.PLACE_ON_TRANSACTION_CHANGE_PAGE, function (resolve) { return function (page) { return resolve(page); }; });
})(PlaceAction || (PlaceAction = {}));
exports.default = PlaceAction;
